import { render } from "./StatusStepsComponent.vue?vue&type=template&id=06fc0f9d&scoped=true&ts=true"
import script from "./StatusStepsComponent.vue?vue&type=script&lang=ts"
export * from "./StatusStepsComponent.vue?vue&type=script&lang=ts"

import "./StatusStepsComponent.vue?vue&type=style&index=0&id=06fc0f9d&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06fc0f9d"]])

export default __exports__